module.exports = __webpack_public_path__ + "img/f_10.96d124b.png";